const assertValue = (value, key) => {
  if (value === undefined) {
    throw new Error(`Missing environment variable: ${key}`);
  }

  return value;
};

// Environment configuration
export const ENV = {
  NODE_ENV: process.env.NODE_ENV || 'development',
  REACT_APP_ENV: process.env.REACT_APP_ENV || 'development',
  DYNAMIC_ENVIRONMENT: process.env.REACT_APP_DYNAMIC_ENVIRONMENT,

  // Keitaro configuration
  KEITARO_CAMPAIGN_URL:
    process.env.REACT_APP_KEITARO_CAMPAIGN_URL ||
    'http://155.138.200.99/fLwg11',

  META_PIXEL_ID: process.env.REACT_APP_META_PIXEL_ID || '25820021464353187',
};
